import { parseAwrp } from '_legacy/services/AwrpFomatterService';

export const AwrpComparator = (valueA, valueB) => {
    if (!valueA && !valueB) {
        return 0;
    }

    if (!valueA) {
        return -1;
    }

    if (!valueB) {
        return 1;
    }
    const parsedValueA = parseAwrp(valueA);
    const parsedValueB = parseAwrp(valueB);
    return parsedValueA - parsedValueB;
};
